import { brand, DEFAULT_BRAND_NAME } from "@roa/domain/brand";

/**
 * The provisional logo of the product: one PNG in `public/brand/`. Swapping the logo is replacing that
 * file (same name) — see ops/docs/SITE_V2_RESULTADO.md. It is shown only while the product keeps its
 * own name: a renamed product (BRAND_NAME) must not wear this logo, it sets BRAND_LOGO_PATH instead.
 */
const DEFAULT_LOGO_PATH = "/brand/roa-logo.png";

/**
 * The brand's mark: the configured logo when there is one (`BRAND_LOGO_PATH`), else the provisional
 * logo file (while the name is the product's own), else the name written as text beside a small
 * orange square with a check — the day's task, done. No `next/image`: a fixed file the browser
 * can cache, at the intrinsic ratio of the PNG (720×289).
 */
export function RoaMark({ onDark = false, className = "" }: { onDark?: boolean; className?: string }) {
  const { logoPath, name, nameTitle } = brand();
  const src = logoPath || (name === DEFAULT_BRAND_NAME ? DEFAULT_LOGO_PATH : "");
  if (src) {
    // eslint-disable-next-line @next/next/no-img-element -- the brand logo is a fixed file (public/brand) or a configured path (BRAND_LOGO_PATH), not an optimised asset
    return <img src={src} alt={nameTitle} width={720} height={289} className={`${/\bh-/.test(className) ? "" : "h-9"} w-auto ${className}`} />;
  }
  return (
    <span className={`inline-flex items-center gap-2 ${className}`}>
      <svg aria-hidden="true" viewBox="0 0 28 28" className="size-7 shrink-0">
        <rect width="28" height="28" rx="7" fill="var(--brand-orange)" />
        <path d="M8 14.5l4 4 8-9" fill="none" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
      <span className={`text-xl font-bold tracking-tight ${onDark ? "text-white" : "text-foreground"}`}>{nameTitle}</span>
    </span>
  );
}
